import React from "react";
import { Text, View } from "@react-pdf/renderer";
import CheckboxGroup from "../../../exportacion_react_pdf/CheckboxGroup";
import TableGroup from "../../../exportacion_react_pdf/TableGroup";
import TextAreaLabel from "../../../exportacion_react_pdf/TextAreaLabel";

// Define el documento
const ExportPaso2 = ({ formData = {}, styles = {} }) => (
  <>
    <View style={styles.section}>
      <Text style={styles.title_1}>II. Diagnóstico</Text>

      <CheckboxGroup
        label="¿En el proyecto productivo trabajan o participan miembros del núcleo familiar?"
        selectedValue={formData?.trabajan_miembros_nucleo_familiar || ""}
      ></CheckboxGroup>

      {formData?.trabajan_miembros_nucleo_familiar === "Sí" && (
        <>
          <TableGroup
            questionTitle="¿Indique qué personas de la familia trabajan en el proyecto y en qué área?"
            headers={[
              "tipo_familia",
              "familiar_otro",
              "administracion",
              "contabilidad",
              "produccion",
              "ventas",
            ]}
            headerDescriptions={[
              "Familiar",
              "Otro tipo",
              "Administración",
              "Contabilidad",
              "Producción",
              "Ventas",
            ]}
            data={formData?.lista_personas_trabajan_proyecto || []}
          />
        </>
      )}

      <CheckboxGroup
        label="¿Las personas de la familia que trabajan en el proyecto productivo reciben remuneración?"
        selectedValue={formData?.personas_trabajan_proyecto_remuneracion || ""}
      ></CheckboxGroup>

      <CheckboxGroup
        label="¿El proyecto productivo hace parte de alguna asociación o cooperativa?"
        selectedValue={formData?.parte_asociacion_coperativa || ""}
      ></CheckboxGroup>

      <CheckboxGroup
        label="¿El proyecto productivo cuenta con misión y visión acorde con la realidad actual?"
        selectedValue={formData?.cuenta_mision_vision || ""}
      ></CheckboxGroup>

      <CheckboxGroup
        label="¿El proyecto productivo cuenta con RUT?"
        selectedValue={formData?.cuenta_rut || ""}
      ></CheckboxGroup>

      <CheckboxGroup
        label="¿El proyecto productivo es responsable de IVA?"
        selectedValue={formData?.responsable_iva || ""}
      ></CheckboxGroup>

      <CheckboxGroup
        label="¿El proyecto productivo tiene definidos procesos para cada producto o servicio?"
        selectedValue={formData?.tienes_definido_procesos || ""}
      ></CheckboxGroup>

      {formData?.tienes_definido_procesos === "Sí" && (
        <TextAreaLabel
          label={"¿Indique los procesos que tiene definidos?"}
          value={formData?.procesos_definidos || ""}
        ></TextAreaLabel>
      )}

      <CheckboxGroup
        label="¿Al comparar los logros obtenidos con los logros proyectados, el nivel de satisfacción de las personas que hacen parte del proyecto productivo o estan vinculadas es?"
        selectedValue={formData?.nivel_satisfaccion || ""}
        options={["Bajo", "Medio", "Alto"]}
      ></CheckboxGroup>

      <CheckboxGroup
        label="¿El grado de compromiso de las personas que hacen parte del proyecto productivo para la consecucion de logros es?"
        selectedValue={formData?.grado_compromiso || ""}
        options={["Bajo", "Medio", "Alto"]}
      ></CheckboxGroup>

      <CheckboxGroup
        label="¿Las decisiones al interior del proyecto productivo se adoptan con la participación de todo el equipo?"
        selectedValue={formData?.deciciones_interior_proyecto || ""}
        options={["Nunca", "Algunas veces", "Frecuentemente"]}
      ></CheckboxGroup>

      {formData?.deciciones_interior_proyecto !== "Nunca" && (
        <TextAreaLabel
          label={"¿Sobre qué temas se toman decisiones conjuntas?"}
          value={formData?.temas_toman_deciciones || ""}
        ></TextAreaLabel>
      )}

      <TextAreaLabel
        label={"¿Qué debilidades considera que tiene el negocio?"}
        value={formData?.debilidades_negocio || ""}
      ></TextAreaLabel>

      <CheckboxGroup
        label="¿El proyecto productivo ha recibido asistencia o ayuda de otras entidades u ONG?"
        selectedValue={formData?.resibido_asistencia_entidades || ""}
      ></CheckboxGroup>

      {formData?.resibido_asistencia_entidades === "Sí" && (
        <TextAreaLabel
          label={
            "¿Indique de cuál organización o entidad su proyecto ha recibido asistencia o ayuda y en qué temas?"
          }
          value={formData?.entidad_recibio_asistencia || ""}
        ></TextAreaLabel>
      )}

      <TextAreaLabel
        label={
          "Conjuntamente entre la persona en reincorporación y el asesor identifiquen una fortaleza representativa del proyecto productivo en temas de empoderamiento (administración, relación con los empleados o familiares, asociatividad)"
        }
        value={formData?.fortaleza_representativa || ""}
      ></TextAreaLabel>

      <TextAreaLabel
        label={
          "Conjuntamente entre la persona en reincorporación y el asesor identifiquen una debilidad representativa del proyecto en temas de empoderamiento (administración, relación con los empleados o familiares, asociatividad)"
        }
        value={formData?.debilidad_representativa || ""}
      ></TextAreaLabel>
    </View>
  </>
);

export default ExportPaso2;
